import { openBlock, createElementBlock, createElementVNode } from "vue";
import { _ as _export_sfc } from "./index-nOmQweDK.mjs";
const _sfc_main = {};
const _hoisted_1 = /* @__PURE__ */ createElementVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M12 2C6.47714 2 2 6.47714 2 12C2 17.5229 6.47714 22 12 22C17.5229 22 22 17.5229 22 12C22 6.47714 17.5229 2 12 2Z",
  fill: "#FFE3CA"
}, null, -1);
const _hoisted_2 = /* @__PURE__ */ createElementVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M12 2C6.47714 2 2 6.47714 2 12C2 17.5229 6.47714 22 12 22C17.5229 22 22 17.5229 22 12C22 6.47714 17.5229 2 12 2ZM12 3.07143C16.9236 3.07143 20.9286 7.07643 20.9286 12C20.9286 16.9236 16.9236 20.9286 12 20.9286C7.07643 20.9286 3.07143 16.9236 3.07143 12C3.07143 7.07643 7.07643 3.07143 12 3.07143Z",
  fill: "#FFD7B1"
}, null, -1);
const _hoisted_3 = /* @__PURE__ */ createElementVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M12.1399 7.33313C11.5099 7.33313 10.8987 7.45688 10.3227 7.70063C9.76766 7.93538 9.26816 8.27138 8.83916 8.70038C8.41166 9.12788 8.07491 9.62738 7.83941 10.1839C7.59641 10.7599 7.47266 11.3711 7.47266 12.0004C7.47266 12.6296 7.59641 13.2409 7.83941 13.8169C8.07416 14.3734 8.41091 14.8721 8.83916 15.3004C9.26741 15.7286 9.76616 16.0654 10.3227 16.3001C11.5017 16.7981 12.8479 16.7891 14.0164 16.2739C14.5879 16.0226 15.0972 15.6641 15.5284 15.2089C15.6949 15.0334 15.7827 14.8031 15.7759 14.5616C15.7699 14.3201 15.6694 14.0951 15.4932 13.9286C15.3169 13.7614 15.0709 13.6661 14.8497 13.6811C14.6052 13.6879 14.3802 13.7884 14.2137 13.9639C13.6692 14.5391 12.9327 14.8564 12.1399 14.8564C10.5649 14.8564 9.28316 13.5746 9.28316 12.0004C9.28316 10.4254 10.5649 9.14363 12.1399 9.14363C12.9319 9.14363 13.6684 9.46088 14.2137 10.0369C14.3794 10.2124 14.6044 10.3129 14.8467 10.3196C15.0919 10.3181 15.3282 10.2274 15.4932 10.0714C15.6694 9.90488 15.7699 9.68063 15.7759 9.43913C15.7827 9.19688 15.6949 8.96738 15.5284 8.79188C15.0957 8.33513 14.5872 7.97738 14.0164 7.72613C13.4239 7.46513 12.7924 7.33313 12.1399 7.33313Z",
  fill: "#FC6020"
}, null, -1);
const _hoisted_4 = [
  _hoisted_1,
  _hoisted_2,
  _hoisted_3
];
function _sfc_render(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    onClick: _cache[0] || (_cache[0] = ($event) => _ctx.$emit("click", $event))
  }, _hoisted_4);
}
const icV2StoveCashColor = /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render]]);
export {
  icV2StoveCashColor as default
};
